<template>
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1376_1916)">
      <path
        d="M19.4062 16.1719H16.5938V18.9844H19.4062V16.1719Z"
        fill="#5EB24A"
      />
      <path
        d="M31.7812 2.8125H30.0938V0H27.2812V2.8125H8.71875V0H5.90625V2.8125H4.21875C1.89253 2.8125 0 4.70503 0 7.03125V31.7812C0 34.1075 1.89253 36 4.21875 36H13.5703H13.7812H18.6864C17.7141 35.1975 16.8673 34.2484 16.1788 33.1875H13.7812H13.5703H4.21875C3.44334 33.1875 2.8125 32.5567 2.8125 31.7812V13.2188H33.1875V16.0312V16.1719V16.1788C34.2484 16.8673 35.1975 17.7142 36 18.6864V16.1719V16.0312V7.03125C36 4.70503 34.1075 2.8125 31.7812 2.8125ZM33.1875 10.4062H2.8125V7.03125C2.8125 6.25584 3.44334 5.625 4.21875 5.625H5.90625V8.4375H8.71875V5.625H27.2812V8.4375H30.0938V5.625H31.7812C32.5567 5.625 33.1875 6.25584 33.1875 7.03125V10.4062Z"
        fill="#5EB24A"
      />
      <path
        d="M13.7812 21.7969H10.9688V24.6094H13.7812V21.7969Z"
        fill="#5EB24A"
      />
      <path
        d="M8.15625 21.7969H5.34375V24.6094H8.15625V21.7969Z"
        fill="#5EB24A"
      />
      <path
        d="M8.15625 16.1719H5.34375V18.9844H8.15625V16.1719Z"
        fill="#5EB24A"
      />
      <path
        d="M8.15625 27.4219H5.34375V30.2344H8.15625V27.4219Z"
        fill="#5EB24A"
      />
      <path
        d="M13.7812 16.1719H10.9688V18.9844H13.7812V16.1719Z"
        fill="#5EB24A"
      />
      <path
        d="M13.7812 27.4219H10.9688V30.2344H13.7812V27.4219Z"
        fill="#5EB24A"
      />
      <path
        d="M26.5 17C21.2534 17 17 21.2534 17 26.5C17 31.7466 21.2534 36 26.5 36C31.7466 36 36 31.7466 36 26.5C35.9941 21.2558 31.7442 17.0059 26.5 17ZM26.8391 19.7388L30.1417 18.4187C30.5165 18.5883 30.8791 18.7837 31.2268 19.0036L31.2355 19.009C31.5772 19.2255 31.9037 19.465 32.213 19.7258L32.2396 19.749C32.3783 19.8672 32.5131 19.9895 32.6442 20.1156C32.6608 20.1319 32.6781 20.1473 32.6946 20.1639C32.8321 20.2981 32.9652 20.4365 33.094 20.5789C33.1047 20.591 33.1149 20.6036 33.1256 20.6157C33.2386 20.7423 33.3473 20.8734 33.4528 21.0067C33.4781 21.0384 33.5035 21.0701 33.5281 21.1018C33.6425 21.25 33.7532 21.4007 33.8577 21.5563L33.1993 24.3549L29.9601 25.4348L26.8399 22.9381L26.8391 19.7388ZM19.4716 21.1037C19.4962 21.072 19.5213 21.0403 19.5466 21.0087C19.6508 20.8765 19.7586 20.7476 19.8699 20.6217C19.882 20.6084 19.8931 20.5948 19.905 20.5815C20.0331 20.4388 20.1656 20.3006 20.3029 20.1667C20.3187 20.1512 20.3344 20.135 20.351 20.1207C20.481 19.9953 20.6148 19.8738 20.7522 19.7563L20.7839 19.7297C21.0904 19.4707 21.4139 19.2327 21.7522 19.0172L21.7645 19.0093C22.1103 18.7899 22.4705 18.5948 22.8432 18.425L26.1609 19.7388V22.9372L23.0405 25.4334L19.8013 24.3555L19.1429 21.5569C19.2484 21.4016 19.3578 21.2512 19.4716 21.1037ZM19.09 31.3593C18.9969 31.2174 18.9079 31.0728 18.823 30.9254L18.8024 30.8899C18.718 30.7433 18.6381 30.5942 18.5628 30.4429L18.5601 30.4381C18.4015 30.1196 18.2622 29.7918 18.1431 29.4564V29.4533C18.0868 29.295 18.0355 29.1328 17.988 28.9696L17.9709 28.9095C17.9274 28.7562 17.888 28.6013 17.8527 28.4447C17.8497 28.4294 17.8458 28.4148 17.8427 28.3997C17.7649 28.0459 17.7091 27.6878 17.6754 27.3271L19.6086 25.0073L22.8254 26.0794L23.759 29.8136L22.225 31.8546L19.09 31.3593ZM28.6087 35.1111C28.4504 35.1504 28.2879 35.1842 28.1254 35.2147C28.1027 35.2192 28.0795 35.2229 28.0567 35.227C27.9184 35.2518 27.7784 35.273 27.6382 35.2903C27.6008 35.2951 27.5636 35.3002 27.5264 35.3047C27.3962 35.3198 27.2648 35.3313 27.133 35.3407C27.0916 35.3435 27.0506 35.3476 27.0092 35.3503C26.8408 35.3606 26.671 35.3667 26.5 35.3667C26.3434 35.3667 26.1877 35.3625 26.0329 35.3543C26.0142 35.3543 25.9962 35.3512 25.9775 35.3498C25.8398 35.3419 25.7026 35.3316 25.5658 35.3183L25.55 35.3153C25.2502 35.2829 24.9521 35.2352 24.6571 35.1729L22.784 32.2402L24.2938 30.2269H28.7062L30.2408 32.2535L28.6087 35.1111ZM35.1596 28.4C35.1564 28.4152 35.1527 28.4298 35.1494 28.445C35.114 28.6015 35.0746 28.7564 35.0313 28.9098L35.0143 28.9699C34.9667 29.1331 34.9155 29.2946 34.859 29.4536V29.4567C34.74 29.7921 34.6008 30.1199 34.442 30.4384L34.4394 30.4432C34.3636 30.5947 34.2838 30.7438 34.1997 30.8902L34.1792 30.9258C34.0947 31.0736 34.0058 31.2178 33.9126 31.359L30.7883 31.8516L29.2436 29.8123L30.1768 26.0791L33.3935 25.007L35.3268 27.3268C35.2932 27.6877 35.2374 28.0461 35.1596 28.4Z"
        fill="#FFE400"
      />
    </g>
    <defs>
      <clipPath id="clip0_1376_1916">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
